import { CustomField } from "@thenounproject/lingo-core";

export { default as TextInput } from "./TextInput";
export { default as NumberInput } from "./NumberInput";
export { default as SelectInput } from "./SelectInput";
export { default as DateInput } from "./DateInput";
export { default as ChecklistInput } from "./ChecklistInput";

import { Props as CustomFieldFiltersProps } from "../CustomFieldsFilters";
export type CustomFieldInputProps = {
  field: CustomField;
} & Pick<CustomFieldFiltersProps, "toggleFilter" | "activeFilters">;
